'use client';

import { useState } from 'react';
import Container from '@/components/ui/container';
import Breadcrumb from '@/components/ui/breadcrumb';
import useCategoryStore from '@/store/category.store';
import { useLocale, useTranslations } from 'next-intl';
import BrandCard from '@/components/brandPage/BrandCard';
import SearchIcon from '@/components/ui/icons/search-icon';
import { arabicLetters, english_letters } from '@/constants/letters';

const BrandsPage = () => {
  const state = useCategoryStore((state) => state);
  const [search, setSearch] = useState('');
  const t = useTranslations('common');
  const language = useLocale();
  return (
    <>
      <Breadcrumb current={t('Brands')} />
      <Container className='my-2 grid grid-cols-2 gap-4 sm:my-6 sm:grid-cols-3 sm:gap-6 md:my-8 md:grid-cols-4 md:gap-8 lg:my-11 lg:grid-cols-6 lg:gap-7.5'>
        <div className='col-span-full flex flex-col gap-7 max-sm:gap-2.5'>
          <div className='flex items-center justify-between'>
            <h1 className='text-2xl font-semibold max-lg:text-xl max-md:text-lg max-sm:text-sm'>
              {t('Brands')}
            </h1>
            <div className='border-border relative rounded-lg border'>
              <input
                placeholder={
                  language == 'en' ? 'Search here...' : 'ابحث هنا ...'
                }
                className='rounded-md px-3 py-2 outline-none max-md:text-sm max-md:placeholder:text-sm max-sm:text-xs max-sm:placeholder:text-xs'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <SearchIcon className='absolute end-3 top-1/2 z-20 size-4 -translate-y-1/2 text-zinc-600 max-md:size-3.5 max-sm:size-3' />
            </div>
          </div>
          <div className='flex items-center gap-7 overflow-x-auto overflow-y-hidden max-lg:gap-6.25 max-md:gap-5.5 max-sm:gap-4'>
            {(language === 'en' ? english_letters : arabicLetters).map(
              (letter) => (
                <button
                  key={letter}
                  onClick={() => setSearch(letter)}
                  className='cursor-pointer text-gray-500 hover:underline max-lg:text-[15px] max-md:text-sm max-sm:text-xs'
                >
                  {letter}
                </button>
              )
            )}
          </div>
        </div>
        {state?.menuTreeData
          ?.filter((category) => category?.name?.toUpperCase().includes(search))
          .map((category) => (
            <BrandCard
              key={category.id}
              info={{
                url: category?.url_key || '#',
                'title-en': category?.name || '',
                'title-ar': category?.name || '',
                'img-en': process.env.NEXT_PUBLIC_IMG_BASEURL + category.image,
                'img-ar': process.env.NEXT_PUBLIC_IMG_BASEURL + category.image,
                'mobile-img-en':
                  process.env.NEXT_PUBLIC_IMG_BASEURL + category.image,
                'mobile-img-ar':
                  process.env.NEXT_PUBLIC_IMG_BASEURL + category.image,
              }}
            />
          ))}
      </Container>
    </>
  );
};

export default BrandsPage;
